/*
 * @Descripttion:
 * @version:
 * @Author: susj
 * @Date: 2020-10-20 16:39:56
 * @LastEditors: susj
 * @LastEditTime: 2020-11-18 20:17:27
 */
import { cloneDeep } from 'lodash';
import { workData2asyncData } from '@/utils/work';

class UndoRedoHistory {
  store;

  history = [];

  curPageUuid = [];


  currentIndex = -1;

  get canUndo() {
    return this.currentIndex > 0;
  }

  get canRedo() {
    return this.history.length > this.currentIndex + 1;
  }

  init(store) {
    this.store = store;
  }

  addState(state) {
    if (this.currentIndex + 1 < this.history.length) {
      this.history.splice(this.currentIndex + 1);
      this.curPageUuid.splice(this.currentIndex + 1);
    }
    if (this.history.length === 21) {
      this.curPageUuid.shift();
      this.history.shift();
      this.currentIndex -= 1;
    }
    this.curPageUuid.push(state.editor.editingPage.uuid);
    this.history.push(state);
    this.currentIndex += 1;
    if (this.store) {
      this.store.commit('editor/setCanUndo', this.canUndo);
      this.store.commit('editor/setCanRedo', this.canRedo);
    }
  }


  undo() {
    if (!this.canUndo) return;
    const prevState = this.history[this.currentIndex - 1];
    // 恢复元素 为edting
    const curPageUuid = this.curPageUuid[this.currentIndex - 1];
    const curPageIndex = prevState.editor.work.pages.findIndex(item => item.uuid === curPageUuid);
    this.store.commit('editor/setEditingPage', curPageIndex);
    this.store.commit('editor/setCanRedo', this.canRedo);
    this.store.dispatch('editor/pptWrapSaveInfo', workData2asyncData(prevState.editor.work));
    this.store.replaceState(cloneDeep(prevState));
    this.currentIndex -= 1;
    this.store.commit('editor/setCanUndo', this.canUndo);
    this.store.commit('editor/setCanRedo', this.canRedo);
  }

  redo() {
    if (!this.canRedo) return;
    const nextState = this.history[this.currentIndex + 1];
    this.store.replaceState(cloneDeep(nextState));
    this.store.dispatch('editor/pptWrapSaveInfo', workData2asyncData(nextState.editor.work));
    // 恢复元素 为edting
    const curPageUuid = this.curPageUuid[this.currentIndex + 1];
    const curPageIndex = nextState.editor.work.pages.findIndex(item => item.uuid === curPageUuid);
    this.store.commit('editor/setEditingPage', curPageIndex);

    this.currentIndex += 1;
    this.store.commit('editor/setCanRedo', this.canRedo);
  }
}

const undoRedoHistory = new UndoRedoHistory();

export default undoRedoHistory;
